import { Component, Input} from '@angular/core';

@Component({
  selector: 'app-emoji',
  template: `<img [src]="emojiSrc" [alt]="name" class="emoji {{size}} {{onHoverAction}}" />`,
  styleUrls: ['./emoji.component.scss']
})
export class EmojiComponent {
  @Input() name!: string;
  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input() onHoverAction: '' | 'enlarge' | 'background-change' = '';

  get emojiSrc(): string {
    return `assets/emojis/${this.name}.png`;
  }
}